import { render } from "./addMatchSubject.vue?vue&type=template&id=18402174&scoped=true"
import script from "./addMatchSubject.vue?vue&type=script&lang=js"
export * from "./addMatchSubject.vue?vue&type=script&lang=js"

import "./addMatchSubject.vue?vue&type=style&index=0&id=18402174&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18402174"]])

export default __exports__